export const ERRORS_LOAD_FONT = 'Failed loading webfont';
export const ERRORS_FILE_STORAGE_DISABLED = 'File storage not enabled';
export const ERRORS_DATA_STORAGE_DISABLED = 'Data storage not enabled';
export const ERRORS_UNSUPPORTED_FEATURE = 'Unsupported feature';
export const ERRORS_OAUTH_FAILED = 'Oauth request failed';
export const ERRORS_INVALID_REQUEST_DATA = 'Invalid request data';
export const ERRORS_INVALID_RETURN_DATA = 'Invalid return data';
export const ERRORS_OFFLINE = 'Not supported in offline modus';
export const ERRORS_NO_RESPONSE = 'No response';
export const ERRORS_UPLOAD_REJECTED_TOO_MANY = 'Upload cannot be added, too many photos selected';

/** Rejection for a selected file whose type the upload controller does not accept. */
export class UnsupportedFileTypeError extends Error {
	public constructor(message: string) {
		super(message);
		this.name = 'UnsupportedFileTypeError';
	}
}

/**
 * Rejection from a save that found failed photo uploads while the global upload
 * error dialog was suppressed by import, select or overview. When the
 * suppression ends each calls AppStateModule.restoreUploadErrorDialog, which
 * re-enables the dialog and saves the still-unsaved product so remaining
 * failures are presented, so callers treat this rejection as expected.
 */
export class UnsavedPhotoModelsError extends Error {
	public constructor() {
		super('Unsaved photo models');
		this.name = 'UnsavedPhotoModelsError';
	}
}
